export default __webpack_public_path__ + "static/media/professor.8d2e5832.png";